const ONLINE = 'przelewy24_single'
const BLIK = 'przelewy24_blik_level_0'
const DRUK = 'direct'
const CARD = 'przelewy24_subscription'

export default {
    ONLINE: ONLINE,
    BLIK: BLIK,
    DRUK: DRUK,
    CARD: CARD,

    isPaymentByCardEnabled() {
        return process.env.VUE_APP_TRANSFER_METHODS_SUBSCRIPTION_ENABLE_PAYMENT_BY_CARD === 'true';
    }
}
